export type ArtistPlatforms = 'spotify' | 'apple' | 'youtube' | 'amazon' | 'tidal' | 'soundcloud';

export const ARTIST_PLATFORMS_LIST: ArtistPlatforms[] = ['spotify', 'apple', 'youtube', 'amazon', 'tidal', 'soundcloud'];